import styled from 'styled-components';

export default styled.div`
  .anticon {
    margin-right: 8px;
  }
  .title {
    height: 80px;
    background-color: #c1e18d;
    width: 100%;
    padding-left: 43px;
    display: flex;
    align-items: center;
    p {
      margin: 0 12px;
      line-height: 30px;
      font-size: 20px;
      font-weight: 700;
    }
    .icon1 {
      font-size: 20px;
    }
  }
  .section {
    margin: 55px 65px;
    .box {
      display: flex;
      justify-content: space-between;
      background-color: white;
      padding: 19px 25px 17px 25px;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      p {
        line-height: 24px;
        font-size: 16px;
        margin: 0;
        font-weight: 700;
      }
      .date {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
      }
    }
    .box1 {
      background-color: #80a445;
      color: white;
      width: 100%;
      padding-top: 10px;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      p:first-child {
        font-size: 14px;
        padding-left: 24px;
        font-weight: 200;
        line-height: 21px;
      }
      .count {
        padding-bottom: 6px;
        text-align: center;
        position: relative;
        border-bottom: 1px dotted white;
        h1 {
          display: inline;
          font-size: 69px;
          font-style: normal;
          font-weight: 400;
          line-height: 69px;
          color: white;
        }
        p {
          display: inline;
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
        }
      }
    }
    .box2 {
      margin-top: 9px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 55px;
      padding-bottom: 54px;

      .btnRight {
        span {
          font-size: 16px;
          font-weight: 700;
          line-height: 21px;
        }
        width: 150px;
        color: #80a445;
        height: 28px;
        padding-left: 29px;
        padding-top: 2px;
        padding-right: 29px;
      }
    }
    .box3 {
      text-align: center;
      padding-top: 14px;
      background-color: white;
      padding-bottom: 30px;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      p {
        padding: 0 !important;
        color: black;
        margin-bottom: 5px;
        font-size: 16px;
        font-weight: 400 !important;
        line-height: 21px;
      }
    }
    .btn {
      background-color: #ff8a00;
      border-radius: 5px;
      font-weight: 700;
      color: white;
      height: auto;
      width: 50%;
      border: none;
      margin-left: 25%;
      margin-right: 25%;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
      padding-top: 18px;
      padding-bottom: 18px;
    }
    .left {
      margin-right: 20px;
      border-radius: 10px;
      box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.25);
      .line {
        background-color: #80a445;
        height: 10px;
        width: 10px;
        position: absolute;
        left: 48%;
        bottom: -6px;
        transform: rotate(45deg);
        border-bottom: 1px dotted white;
        border-right: 1px dotted white;
      }
    }
    .right {
      .box3 {
        padding-top: 39px;
      }
      border-radius: 10px;
      box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.25);
      margin-left: 20px;
      .line {
        background-color: #80a445;
        height: 10px;
        width: 10px;
        position: absolute;
        right: 50%;
        bottom: -5px;
        transform: rotate(45deg);
        border-bottom: 1px dotted white;
        border-right: 1px dotted white;
      }
      .box2 {
        display: block;
        flex-direction: column;
        justify-content: flex-start;
        padding-left: 25px;
        padding-top: 30px;
        padding-bottom: 17px;

        h3 {
          color: white;
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
          margin: 0 5px;
        }
        p {
          font-size: 14px;
          font-weight: 400;
          line-height: 21px;
          margin: 0;
        }
      }
    }
  }
  .space {
    margin-left: 15px !important;
  }
  .boxMini2 {
    display: flex;
    align-items: center;
    margin-bottom: 13px;
  }
  .bottom {
    margin: 40px 65px;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.25);
    background-color: white;
    padding: 30px 86px;
    width: auto;
    height: 155px;
    display: flex;
    justify-content: space-between;
    border-radius: 10px;
    .btnBottom {
      width: 349px;
      height: 95px;
      border-radius: 5px;
      background-color: #ff8a00;
      box-shadow: 0 2px 4px 0 #00000033;

      span {
        font-size: 20px;
        font-weight: 700;
        line-height: 30px;
        color: white;
      }
    }
  }
  .ant-btn {
    font-size: 16px;
  }
  @media screen and (max-width: 844px) {
    .section {
      margin: 20px 10px;
      > .ant-row {
        flex-direction: column;
        > .ant-col {
          max-width: 100%;
        }
        .left,
        .right {
          margin: 0 0 10px;
        }
        .box2 .btnRight {
          width: 110px;
          padding-right: 10px;
          padding-left: 10px;
        }
      }
    }
    .bottom {
      margin: 20px 10px;
      padding: 10px;
      flex-direction: column;
      align-items: center;
      .btnBottom {
        max-width: 100%;
      }
    }
  }
`;
